import i18next from 'i18next'
import { List } from 'immutable'
import { getLastSegment } from '../utils/breadcrumbs'
import { routeUpdaters } from '../site/root/routes/routesState'

export const subscriptionRoute = () =>
  List([
    {
      url: routeUpdaters(i18next.language).dashboard.url,
      label: getLastSegment(routeUpdaters(i18next.language).dashboard.url),
    },
    {
      url: routeUpdaters(i18next.language).accountDetails.url,
      label: getLastSegment(routeUpdaters(i18next.language).accountDetails.url),
    },
  ])

export const formatSubscriptionPrice = (price: number, language: string) =>
  price.toLocaleString(language, {minimumFractionDigits: 2, maximumFractionDigits: 2})
